import './index.scss';
import React, { useEffect, useMemo, useState } from 'react';
import { IPermissionContentProps } from '../../interface';
import { getPermissionList } from '@umu/umu-api';
import { PermissionType } from '../../../../interface';
import { shareOptionMap } from './../../../../dataFlow';
import { getSessionInfo, getSessionTimingInfo } from '../../../../server';
import { If } from 'common/src/components';
import { lang } from '@umu/ukit-lang';
import { CoursePermissionInfo } from '../course';

const SessionPermissionInfo = (props: IPermissionContentProps) => {
    const {
        id,
        prefixCls = 'session-permission-info',
        showRefresh = false,
        normalizeAccountEPU,
        normalizeAccountName,
    } = props;
    const [dataInfo, setDataInfo] = useState<any>({
        permission: PermissionType.__INIT__,
        sessionInfo: null,
        timingInfo: null,
    });
    const onInit = (callBack?: () => void) => {
        Promise.all([
            getPermissionList({
                obj_id: id,
                obj_type: 'session',
            }),
            getSessionInfo({
                session_id: id,
            }),
            getSessionTimingInfo({
                session_ids: id,
            }),
        ]).then(([permissionInfo, sessionInfo, timingInfo]) => {
            setDataInfo({
                permission: permissionInfo.selected as PermissionType,
                sessionInfo,
                timingInfo,
            });
            callBack?.();
        });
    };
    useEffect(() => {
        onInit();
    }, [id]);
    const onRefresh = () => {
        if (props?.onRefresh) {
            props?.onRefresh?.();
            return;
        }
        onInit();
    };
    const { label } = useMemo(() => {
        const permission = String(dataInfo.permission) as PermissionType;
        return {
            label: shareOptionMap?.[permission]?.sessionLabel,
        };
    }, [dataInfo.permission]);

    return (
        <div className={prefixCls}>
            <div className={`${prefixCls}-rows-split`}>
                <span className={`${prefixCls}-sub-title`}>{lang('小节')}</span>
                <span>{label}</span>
            </div>
            <If condition={!!dataInfo.sessionInfo?.groupId}>
                <div className={`${prefixCls}-rows-split ${prefixCls}-course-info`}>
                    <div className={`${prefixCls}-sub-title`}>{lang('所属课程')}</div>
                    <CoursePermissionInfo
                        id={dataInfo.sessionInfo?.groupId}
                        showRefresh={showRefresh}
                        prefixCls={`${prefixCls}-course`}
                        onRefresh={onRefresh}
                        normalizeAccountEPU={normalizeAccountEPU}
                        normalizeAccountName={normalizeAccountName}
                    />
                </div>
            </If>
        </div>
    );
};
export { SessionPermissionInfo };
